import { useForm } from 'react-hook-form';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { Button, Container, Dialog, Grid, IconButton, Paper, Stack, Typography, Box } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  BASE_URL,
  dateFormatter,
  dropdownFetch,
  formatDate,
  getCurrentDateTime,
  request,
  toast
} from '../../../../../utils';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import { IndoorBillingManagementReport } from '../Reports/indoorBillingManagementReport';
import { IPDSearchHandler } from './utils';
import { YES_NO } from '../../../../../constants/dropdown';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { IPDSearchHandlerBillManagement } from './utils/IPDSearchHandlerBillManagement';
import { FinalBillAddDetailsForm, FinalBillDetailsForm } from './FinalBillAddDetailsForm';
import { OPDBillingDetailForm } from './OPDBillingDetailForm';
import { ConfirmDetailsDialogue } from './ConfirmDetailsDialogue';
import { FinalBillTable } from './utils/FinalBillTable';
import axios from 'axios';
import { IPDSearchHandlerAllBillManagement } from './utils/IPDSearchHandlerAllBillManagement';

const TABLE_HEADER = [
  {
    header: 'Doc No. ',
    accessor: 'receipt_no'
  },
  {
    header: 'Doc Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID NO',
    accessor: (row) => row?.patient?.uhid
  },
  {
    header: 'IPD No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name ',
    accessor: (row) => `${row.patient?.first_name} ${row?.patient?.last_name}`
  },
  {
    header: ' Amount',
    accessor: 'received_amount'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];

const REFUND_TABLE_HEADER = [
  {
    header: 'Doc No. ',
    accessor: 'doc_no'
  },
  {
    header: 'Doc Date',
    accessor: (row) => `${getCurrentDateTime('date', row.createdAt)}`
  },
  {
    header: 'UHID NO',
    accessor: (row) => row?.patient?.uhid
  },
  {
    header: 'IPD No.',
    accessor: 'ipd_no'
  },
  {
    header: 'Patient Name ',
    accessor: (row) => `${row.patient?.first_name} ${row?.patient?.last_name}`
  },
  {
    header: ' Amount',
    accessor: 'amount'
  },
  {
    header: 'Status',
    accessor: 'status',
    sx: { textTransform: 'uppercase' }
  }
];
const GROUP_TABLE_HEADER = [
  {
    header: 'Group',
    accessor: (row) => {
      if (row?.group === 'L') return 'LAB';
      if (row?.group === 'R') return 'RADIOLOGY';
      if (row?.group === 'S') return 'SERVICE';
      if (row?.group === 'SR') return 'SURGERY';
      if (row?.group === 'Pc') return 'PACKAGE';
      if (row?.group === 'room charge') return 'Room Charge';
    }
  },
  {
    header: 'Net Amount',
    accessor: (row) => `${row?.net_amt}`
  }
];

const initialIpdBillingManagementDataObj = {
  data: [],
  loading: false
};

const initialReceiptVoucherDataObj = {
  data: [],
  loading: false
};

const initialRefundVoucherDataObj = {
  data: [],
  loading: false
};

export const IndoorBillingManagement = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [loading, setLoading] = useState(false);
  const [groupDetailList, setGroupDetailList] = useState({ data: [], activeSelection: '' });
  const [serviceList, setServiceList] = useState([]);
  const [IPDSearchDialogOpen, setIPDSearchDialogOpen] = useState(false);
  const [additionalActionDialogOpen, setAdditionalActionDialogOpen] = useState(false);
  const [ipdAllDetailListDialogue,setIpdAllDetailListDialogue] = useState(false)
  const [openPrint, setOpenPrint] = useState(false);
  const [reportId, setReportId] = useState(null);
  const [balance, setBalance] = useState(0);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [receiptVoucherDataObj, setReceiptVoucherDataObj] = useState(initialReceiptVoucherDataObj);
  const [refundVoucherDataObj, setRefundVoucherDataObj] = useState(initialRefundVoucherDataObj);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [ipdno, setIpdNo] = useState('');
  const [uhid, setUhid] = useState('');
  const [selectedRecord, setSelectedRecord] = useState([]);
  const [currentAction, setCurrentAction] = useState();
  const [discountAdded, setAddDiscountAdded] = useState(0);
  const [roombill, setRoombill] = useState([]);
  const [sponsor, setSponsor] = useState('');
  const [isEditMode, setIsEditMode] = useState(false);
  const [editData, setEditData] = useState([]);
  const [addDetailsDialogOpen, setAddDetailsDialogOpen] = useState(false);
  const [testDropdown, setTestDropdown] = useState([]);
  const [serviceDropdown, setServiceDropdown] = useState([]);
  const [confirmDialogue, setConfirmDialogue] = useState(false);
  const [rowToDelete, setRowToDelete] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [inputValues, setInputValues] = useState([]);
  const [totalReceivedAmount, setTotalRecievedAmount] = useState(0);
  const [totalRefundAmount, setTotalRefundAmount] = useState(0);
  const [netAmount, setNetAmount] = useState(0);
  const [refundQueryWindow, setRefundQueryWindow] = useState(false);
  const [indoorTotalReceipt, setIndoorTotalReceipt] = useState(0);
  const [totalDisc, setTotalDisc] = useState(0);
  const [finalBillTotalDisc, setFinalBillTotalDisc] = useState(0);
  const[selectedRow,setSelectedRow] = useState(false)
  const doctorIDRef = useRef();
  const sponsorIDRef = useRef();

  const SERVICE_NAME_TABLE_HEADER = [
    {
      header: 'Date',
      accessor: (row) => (row?.date ? formatDate(row?.date) : formatDate(row.billingDate))
    },
    // Conditionally rendering 'Ward Name' based on groupDetailList.activeSelection
    ...(groupDetailList.activeSelection === 'S' || 'R' || 'L' || 'Pc'
      ? [
          {
            header: 'type',
            accessor: (row) => `${row?.type || ''}`
          }
        ]
      : []),
    {
      header: 'Service Name',
      accessor: (row) => `${row?.service_name || 'Room Charge'}`
    },
    // Conditionally rendering 'Ward Name' based on groupDetailList.activeSelection
    ...(groupDetailList.activeSelection === 'room charge'
      ? [
          {
            header: 'Ward Name',
            accessor: (row) => `${row?.ward_name || ''}`
          }
        ]
      : []),
    // Conditionally rendering 'Ward Name' based on groupDetailList.activeSelection
    ...(groupDetailList.activeSelection === 'room charge'
      ? [
          {
            header: 'Room',
            accessor: (row) => `${row?.room_no || ''}`
          }
        ]
      : []),
    // Conditionally rendering 'Ward Name' based on groupDetailList.activeSelection
    ...(groupDetailList.activeSelection === 'room charge'
      ? [
          {
            header: 'Bed No',
            accessor: (row) => `${row?.bed_no || ''}`
          }
        ]
      : []),
    {
      header: 'quantity',
      accessor: (row) => (row?.type === 'room charge' ? `${row?.quantity || 1}` : `${row?.quantity || 1}`)
    },
    {
      header: 'rate',
      accessor: (row) => row?.rate || 0
    },
    {
      header: 'Amount',
      accessor: (row) => row?.quantity * row?.rate || 0
    },
    {
      header: 'Disc%',
      accessor: (row) => `${(row?.disc_amt / (row?.quantity * row?.rate)) * 100 || 0}`
    },
    {
      header: 'disc_amt',
      accessor: (row) => `${row?.disc_amt || 0}`
    },
    {
      header: 'net_amt',
      accessor: (row) => {
        const totalAmount = row?.rate * row?.quantity;
        return totalAmount - Number(row?.disc_amt || 0);
      }
    }
  ];

  const user = JSON.parse(localStorage.getItem('user'));
  const isEnabledDate =
    user && user.permissions ? user.permissions.some((permission) => permission.includes('DatePermission')) : false;

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        tpa: Yup.string().required(' ')
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5),
      bill: {
        is_implant_surgery: 'No'
      }
    },
    mode: 'all'
  });
  const { handleSubmit, reset, watch, setValue } = methods;

  useEffect(() => {
    const init = 0;
    const stats = { net_amt: 0, gst_amt: 0 };
    const groupValueList = {
      'room charge': init,
      L: init,
      R: init,
      S: init,
      SR: init,
      Pc: init
    };

    // Iterate through the serviceList and calculate totals
    serviceList.forEach((item) => {
      const groupKey = item?.type;

      if (groupValueList.hasOwnProperty(groupKey)) {
        groupValueList[groupKey] += item.net_amt;
      } else {
        groupValueList[groupKey] = item.net_amt;
      }

      stats.net_amt += item.net_amt;
      stats.gst_amt += item.gst_amt;
    });

    // Set the net_amt and gst_amt values for the bill

    setValue('bill.net_amt', stats.net_amt);
    setNetAmount(stats.net_amt);
    setValue('bill.gst_amt', stats.gst_amt);

    // Create the groupDetailList based on the groupValueList
    const groupDetailListData = Object.keys(groupValueList).map((key) => ({
      group: key,
      net_amt: groupValueList[key]
    }));

    // Set the activeSelection if it is undefined or null
    const currentActiveSelection = groupDetailList.activeSelection || groupDetailListData[0]?.group || '';

    // Update groupDetailList state (data and activeSelection)
    setGroupDetailList({
      data: groupDetailListData,
      activeSelection: currentActiveSelection
    });
  }, [serviceList]); // Run effect when serviceList changes

  const addDiscount = watch('add_discount');

  const searchIPDRegisterationDetails = async (ipdNo) => {
    setLoading(true);
    const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipdNo
    });
    if (response?.success) {
      const { data } = response;
      if (!data) {
        toast('No patient found', { variant: 'warning' });
      } else {
        const serviceData = [];
        const { indoorService, roomChargeTracker = [], receiptvouchers = [], refundvoucher = [] } = data;
        const totalReceipt = receiptvouchers.reduce((acc, voucher) => {
          return acc + voucher.received_amount;
        }, 0);
        setTotalRecievedAmount(totalReceipt);

        const totalRefund = refundvoucher.reduce((acc, voucher) => {
          return acc + voucher.amount;
        }, 0);

        setTotalRefundAmount(totalRefund);

        const indoorServiceTotalReceipt = indoorService.reduce((acc, receipt) => {
          return acc + receipt.total_recpt;
        }, 0);

        setIndoorTotalReceipt(indoorServiceTotalReceipt);

        const indoorServiceTotalDisc = indoorService.reduce((acc, receipt) => {
          return acc + receipt.disc_amt;
        }, 0);

        setTotalDisc(indoorServiceTotalDisc);

        const finalBillDiscAmount = indoorService.reduce((acc, receipt) => {
          return acc + receipt.add_discount;
        }, 0);

        setFinalBillTotalDisc(finalBillDiscAmount);

        roomChargeTracker.forEach((item) => {
          serviceData.push({
            type: 'room charge',
            rate: item.charge,
            disc_amt: item.disc_amt,
            quantity: 1,
            net_amt: item.net_amt,
            room_no: item.room_no,
            amount: item.charge, // assuming that the charge is per day
            service: 'room_charge',
            ward_name: item.ward_name,
            date: item.date, // Adding the date from roomChargeTracker
            bed_no: item.bed_no,
            room_id: item.room_id,
            _id: item._id
          });
        });

        // Iterate through indoor services
        indoorService.forEach(({ service_items, bill_no }) =>
          service_items
            .filter((service) => service.service_status === 'active')
            .forEach((service) => {
              serviceData.push({
                ...service,
                bill_no,
                quantity: service.type === 'room charge' ? 1 : service.quantity
              });
            })
        );

        setServiceList(serviceData);
        setSelectedRow(false)
        setValue('bill.ipd_no', data?.ipd_no);
        // setAddDiscountAdded(data?.indoorService[0]?.add_discount);
        setIpdNo(data?.ipd_no);
        setValue('uhid', data?.uhid);
        setUhid(data?.uhid);
        setValue('admission_date', formatDate(data?.admissionDate));
        setValue('admission_time', data?.admissionTime);
        setValue('discharge_mode', data?.patientDischarge?.discharge_mode);
        setValue('dis_date', formatDate(data?.patientDischarge?.date) === null ? '' : data?.patientDischarge?.date);
        setValue('dis_time', data?.patientDischarge?.time || '');
        setValue('patient_name', `${data?.patient?.first_name} ${data?.patient?.last_name}`);
        setValue('address', data?.patient?.address?.address);
        setValue('mobile', data?.patient?.address?.mobile);
        setValue('sponsor', data?.patient?.sponsor?.name);
        setValue('vertical', data?.patient?.vertical?.verticalname);
        setValue('ward', data?.consultant_detail?.room?.ward?.name);
        setValue('bed_no', data?.consultant_detail?.bed_no);
        setValue('consultant', data?.consultant_detail?.doctor?.name);
        doctorIDRef.current = data?.consultant_detail?.doctor?._id;
        setValue('receipt_voucher_amt', totalReceipt);
        setValue('refund_voucher_amt', totalRefund);
        setValue('discounted_amount', indoorServiceTotalDisc);
        setValue('final_bill_discount', finalBillDiscAmount);

        setSponsor(data?.patient?.sponsor?.name);
        sponsorIDRef.current = data?.patient?.sponsor?._id;

        setReportId(data?.indoorService[0]?._id);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };




  const searchIPDRegisterationDetailfind = async (ipdNo) => {
    setLoading(true);
    const response = await request('/indoor-registeration-detail', {
      method: 'GET',
      params: ipdNo
    });
    if (response?.success) {
      const { data } = response;
      if (!data) {
        toast('No patient found', { variant: 'warning' });
      } else {
        const serviceData = [];
        const { indoorService, roomChargeTracker = [], receiptvouchers = [], refundvoucher = [] } = data;
        const totalReceipt = receiptvouchers.reduce((acc, voucher) => {
          return acc + voucher.received_amount;
        }, 0);
        setTotalRecievedAmount(totalReceipt);

        const totalRefund = refundvoucher.reduce((acc, voucher) => {
          return acc + voucher.amount;
        }, 0);

        setTotalRefundAmount(totalRefund);

        const indoorServiceTotalReceipt = indoorService.reduce((acc, receipt) => {
          return acc + receipt.total_recpt;
        }, 0);

        setIndoorTotalReceipt(indoorServiceTotalReceipt);

        const indoorServiceTotalDisc = indoorService.reduce((acc, receipt) => {
          return acc + receipt.disc_amt;
        }, 0);

        setTotalDisc(indoorServiceTotalDisc);

        const finalBillDiscAmount = indoorService.reduce((acc, receipt) => {
          return acc + receipt.add_discount;
        }, 0);

        setFinalBillTotalDisc(finalBillDiscAmount);

        roomChargeTracker.forEach((item) => {
          serviceData.push({
            type: 'room charge',
            rate: item.charge,
            disc_amt: item.disc_amt,
            quantity: 1,
            net_amt: item.net_amt,
            room_no: item.room_no,
            amount: item.charge, // assuming that the charge is per day
            service: 'room_charge',
            ward_name: item.ward_name,
            date: item.date, // Adding the date from roomChargeTracker
            bed_no: item.bed_no,
            room_id: item.room_id,
            _id: item._id
          });
        });

        // Iterate through indoor services
        indoorService.forEach(({ service_items, bill_no }) =>
          service_items
            .filter((service) => service.service_status === 'active')
            .forEach((service) => {
              serviceData.push({
                ...service,
                bill_no,
                quantity: service.type === 'room charge' ? 1 : service.quantity
              });
            })
        );

        setServiceList(serviceData);
        setValue('bill.ipd_no', data?.ipd_no);
        // setAddDiscountAdded(data?.indoorService[0]?.add_discount);
        setIpdNo(data?.ipd_no);
        setValue('uhid', data?.uhid);
        setUhid(data?.uhid);
        setValue('admission_date', formatDate(data?.admissionDate));
        setValue('admission_time', data?.admissionTime);
        setValue('discharge_mode', data?.patientDischarge?.discharge_mode);
        setValue('dis_date', formatDate(data?.patientDischarge?.date) === null ? '' : data?.patientDischarge?.date);
        setValue('dis_time', data?.patientDischarge?.time || '');
        setValue('patient_name', `${data?.patient?.first_name} ${data?.patient?.last_name}`);
        setValue('address', data?.patient?.address?.address);
        setValue('mobile', data?.patient?.address?.mobile);
        setValue('sponsor', data?.patient?.sponsor?.name);
        setValue('vertical', data?.patient?.vertical?.verticalname);
        setValue('ward', data?.consultant_detail?.room?.ward?.name);
        setValue('bed_no', data?.consultant_detail?.bed_no);
        setValue('consultant', data?.consultant_detail?.doctor?.name);
        doctorIDRef.current = data?.consultant_detail?.doctor?._id;
        setValue('receipt_voucher_amt', totalReceipt);
        setValue('refund_voucher_amt', totalRefund);
        setValue('discounted_amount', indoorServiceTotalDisc);
        setValue('final_bill_discount', finalBillDiscAmount);
        setSponsor(data?.patient?.sponsor?.name);
        sponsorIDRef.current = data?.patient?.sponsor?._id;
        setReportId(data?.indoorService[0]?._id);
      }
    } else {
      toast('Failed to load patient details', { variant: 'error' });
    }
    setLoading(false);
  };



  useEffect(() => {
    setValue('bill.balance_amt', balance);
  }, [balance]);

  useEffect(() => {
    setValue(
      'bill.balance_amt',
      Math.round(
        netAmount + totalRefundAmount - (totalReceivedAmount + indoorTotalReceipt + finalBillTotalDisc + totalDisc)
      )
    );
  }, [totalReceivedAmount, netAmount, totalRefundAmount, indoorTotalReceipt, finalBillTotalDisc, totalDisc]);

  useEffect(() => {}, [searchIPDRegisterationDetails]);

  const handleQueryWindow = async () => {
    try {
      setOpenQueryDialog(true);
      setReceiptVoucherDataObj({ loading: true });

      const response = await request('/receipt-voucher-list', { method: 'GET' });
      if (response.success) {
        // Access the nested data correctly
        const sortedData = response?.data?.data?.filter((item) => item.ipd_no === ipdno);
        setReceiptVoucherDataObj({ loading: false, data: sortedData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setReceiptVoucherDataObj({ loading: false });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setReceiptVoucherDataObj({ loading: false });
    }
  };

  const handleQueryWindowRefund = async () => {
    try {
      setRefundQueryWindow(true);
      setRefundVoucherDataObj({ loading: true });
      const response = await request('/payment-refund-voucher-list', { method: 'GET' });
      if (response.success) {
        const sortedData = response?.data?.data?.filter((item) => item.ipd_no === ipdno);
        setRefundVoucherDataObj({ loading: false, data: sortedData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setRefundVoucherDataObj({ loading: false });
      }
    } catch (error) {
      toast('Error in fetching data', { variant: 'error' });
      setRefundVoucherDataObj({ loading: false });
    }
  };
  const addDiscountAmount = async () => {
    const requestBody = {
      add_discount: Number(addDiscount)
    };

    const response = await request(`/ipd-billing-update`, {
      method: 'PUT',
      params: reportId,
      body: requestBody
    });
    if (response?.success) {
      toast(`Successfully Updated Discount`, { variant: 'success' });
      setFinalBillTotalDisc(finalBillTotalDisc + requestBody.add_discount);
      setValue('add_discount', '');
    } else {
      toast(`Failed to update Discount`, { variant: 'error' });
    }
  };

  const balanceAmt = watch('bill.balance_amt');

  const formSubmit = async (formValue) => {
    if (sponsor?.toLowerCase() === 'general' && balanceAmt !== 0) {
      toast(`The Balance is Pending`, {
        variant: 'warning'
      });
      return;
    }
    setLoading(true);
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '' : '/final-bill-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        uhid: formValue.uhid,
        ...formValue.bill,
        ...formValue,
        createdBy: user.name,
        organisation
      }
    });

    if (response?.success) {
      toast(`Successfully ${editFlag ? 'updated' : 'created'} Final Bill`, {
        variant: 'success'
      });
      setSelectedRecord(response?.data);
      setCurrentAction();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'update' : 'create'} Final Bill`, {
        variant: 'error'
      });
    }

    setLoading(false);
  };

  const handleConfirmDelete = () => {
    if (rowToDelete) {
      handleRowDelete(rowToDelete);
      setConfirmDialogue(false);
    }
  };

  const handleRowDelete = async (row) => {
    const rowId = row ? row.trim() : null;
    if (!rowId) {
      return;
    }
    setLoading(true);
    try {
      const response = await request('/ipd-billing-service-inactive', {
        method: 'PUT',
        body: {
          rowId,
          ipdno
        }
      });
      if (response?.success) {
        toast(`Successfully deleted the row with ID: ${rowId}`, {
          variant: 'success'
        });

        setServiceList((prevServiceList) => {
          const updatedServiceList = prevServiceList.filter((item) => {
            const serviceId = item.service ? item.service.trim() : null;
            if (!serviceId) {
              return true;
            }
            return serviceId !== rowId;
          });
          return updatedServiceList;
        });
      } else {
        toast(`Failed to delete the row with ID: ${rowId}`, {
          variant: 'error'
        });
      }
    } catch (error) {
      console.error('Error making PUT request:', error);
      toast(`Error occurred while deleting the row. Please try again.`, {
        variant: 'error'
      });
    }
    setLoading(false);
  };

  const handleRowDeleteTrigger = (row) => {
    const rowId = row ? row.trim() : null;
    if (!rowId) {
      return;
    }
    setRowToDelete(rowId);
    setConfirmDialogue(true);
  };

  const getServiceDropdown = useCallback(async () => {
    const data = await dropdownFetch('service');
    setServiceDropdown(data);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    setSponsorDropdown(data);
  }, []);

  const getTestDropdown = useCallback(async () => {
    const data = await dropdownFetch('lis-test');
    setTestDropdown(data);
  }, []);

  useEffect(() => {
    getServiceDropdown();
    getTestDropdown();
    getSponsorDropdown();
  }, [getServiceDropdown, getTestDropdown, getSponsorDropdown]);

  const onDetailAddHandler = async (data) => {
    const existingDetailIndex = serviceList.findIndex(({ service }) => service === data.service);
    if (existingDetailIndex === -1) {
      setLoading(true);
      try {
        const serviceName = serviceDropdown.find(({ _id }) => _id === data.service)?.service_name;
        const testName = testDropdown.find(({ _id }) => _id === data.service)?.test_name;
        const response = await request('/ipd-billing-service-add', {
          method: 'PUT',
          body: {
            data: data,
            ipdno
          },
          headers: {
            'Content-Type': 'application/json'
          }
        });
        if (response?.success) {
          setServiceList((prev) => [
            ...prev,
            {
              ...data,
              service_name: serviceName || testName
            }
          ]);
          toast('Service added successfully', { variant: 'success' });
        } else {
          toast('Failed to add the service', { variant: 'error' });
        }
      } catch (error) {
        console.error('Error occurred during API request:', error);
        toast('An error occurred while adding the service. Please try again.', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    } else {
      toast('This service already exists in the list', { variant: 'info' });
    }
  };

  const isSelected = (row, field) => {
    const selectedRow = selectedRows.find((selectedRow) => selectedRow._id === row._id);
    return selectedRow ? selectedRow[field] : false;
  };

  const handleRowSelect = (row, field) => {
    setSelectedRows((prevSelectedRows) => {
      const existingRow = prevSelectedRows.find((selectedRow) => selectedRow._id === row._id);

      if (existingRow) {
        // Toggle selection state
        return prevSelectedRows.filter((selectedRow) => selectedRow._id !== row._id);
      } else {
        // Add row to the selectedRows
        return [...prevSelectedRows, { ...row, [field]: true }];
      }
    });
  };

  const handleInputChange = (e, rowId, header) => {
    const { value } = e.target;

    // Function to calculate net_amt
    const calculateNetAmt = (row) => {
      const totalAmount = row?.rate * row?.quantity;
      const discountAmount = Number(row?.disc_amt || 0);
      return totalAmount - discountAmount;
    };
    const calculateTotalAmount = (row) => {
      const totalAmount = row?.rate * row?.quantity || 0;
      //const discountAmount = Number(row?.disc_amt );
      return totalAmount;
    };

    // Update serviceList and selectedRows
    setServiceList((prevData) =>
      prevData.map((row) => {
        if (row._id === rowId || row.service === rowId) {
          const updatedRow = {
            ...row,
            [header]: value
          };

          // Recalculate net_amt whenever relevant fields are changed
          return {
            ...updatedRow,
            net_amt: calculateNetAmt(updatedRow),
            amount: calculateTotalAmount(updatedRow)
          };
        }
        return row;
      })
    );

    setSelectedRows((prevSelectedRows) =>
      prevSelectedRows.map((row) => {
        if (row._id === rowId || row.service === rowId) {
          const updatedRow = {
            ...row,
            [header]: value
          };

          // Recalculate net_amt here as well
          return {
            ...updatedRow,
            net_amt: calculateNetAmt(updatedRow),
            amount: calculateTotalAmount(updatedRow)
          };
        }
        return row;
      })
    );
  };

  const handleUpdateServices = async () => {
    const filterRoomcharge = selectedRows.filter((item) => item.type === 'room charge');
    const filterServiceCharge = selectedRows.filter((item) => item.type !== 'room charge');

    setLoading(true);
    try {
      const response = await axios.post(`${BASE_URL}/update-indoor-service-in-finalbill/${ipdno}/${uhid}`, {
        serviceItems: filterServiceCharge,
        roomItems: filterRoomcharge
      });

      if (response?.status === 200) {
        toast('Service added successfully', { variant: 'success' });
      } else {
        toast('Failed to add the service', { variant: 'error' });
      }
    } catch (error) {
      console.error('Error occurred during API request:', error);
      toast('An error occurred while adding the service. Please try again.', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: '100vw',
            boxSizing: 'border-box',
            minWidth: '100%'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Final Bill
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <Button type="submit" variant="contained" disabled={selectedRow}>
                  Generate Bill
                </Button>
                <Button disabled={selectedRows.length === 0} onClick={handleUpdateServices} variant="contained">
                  Update Services
                </Button>
                <Button variant="contained" onClick={() => setOpenPrint(true)}>
                  Print Options
                </Button>
                <Button variant="contained" onClick={() => setIpdAllDetailListDialogue(true)}>
                All Patient
                </Button>
                <Button variant="contained" onClick={() => reset()}>
                  Reset
                </Button>
                <Button variant="contained">Refresh</Button>
                <Button variant="contained">Exit</Button>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Bill No.</Typography>
                    <TextField sx={{ flex: 0.8 }} name="bill_no" disabled placeholder="Bill No." />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Patient Name</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Patient Name" name="patient_name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Vertical Type</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} placeholder="Vertical Type" name="vertical" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Adm. Date/Time</Typography>
                    <TextField disabled sx={{ flex: 0.3 }} placeholder="Admission Date" name="admission_date" />
                    <TextField disabled sx={{ flex: 0.3 }} placeholder="Admission Time" name="admission_time" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>TPA Claim Id</Typography>
                    <TextField sx={{ flex: 0.8 }} placeholder="TPA Claim ID" name="tpa_claim_id" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.6, fontWeight: 700, fontSize: '1.4rem' }}>Is Implant Surgery</Typography>
                    <SelectTag formControlSX={{ flex: 0.4 }} name="bill.is_implant_surgery" menus={YES_NO} />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Bill Date/Time</Typography>
                    <TextField
                      sx={{ flex: 0.5 }}
                      name="date"
                      type="date"
                      placeholder="Date"
                      disabled={!isEnabledDate}
                    />
                    <TextField
                      sx={{ flex: 0.3 }}
                      name="time"
                      type="time"
                      placeholder="Time"
                      disabled={!isEnabledDate}
                    />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Address</Typography>
                    <TextField disabled name="address" sx={{ flex: 0.8 }} placeholder="Address" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Ward Name</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="ward" placeholder="Ward Name" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Dis Date/Time</Typography>
                    <TextField disabled sx={{ flex: 0.4 }} name="dis_date" />
                    <TextField disabled sx={{ flex: 0.4 }} name="dis_time" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Remarks 1</Typography>
                    <TextField sx={{ flex: 0.8 }} name="remakrs_1" placeholder="Remarks" />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Ipd No.</Typography>
                    <TextField sx={{ flex: 0.7 }} name="bill.ipd_no" disabled placeholder=" Search By Ipd No." />
                    <Button
                      onClick={() => setIPDSearchDialogOpen(true)}
                      sx={{ flex: 0.1, minWidth: 0, p: 0.25, height: '100%' }}
                      variant="contained"
                    >
                      <SearchIcon />
                    </Button>
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Phone</Typography>
                    <TextField sx={{ flex: 0.8 }} disabled name="mobile" placeholder="Phone No." />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Bed No.</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="bed_no" placeholder="Bed No." />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Discharge Mode</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="discharge_mode" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Remarks 2</Typography>
                    <TextField sx={{ flex: 0.8 }} name="remakrs_2" placeholder="Remarks" />
                  </Stack>
                </Grid>
                <Grid item xs={3} sx={{ display: 'flex', gap: 0.3, flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Uhid No.</Typography>
                    <TextField sx={{ flex: 0.8 }} name="uhid" placeholder="Uhid No." disabled />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Sponsor</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="sponsor" placeholder="Sponsor" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Consultant</Typography>
                    <TextField disabled sx={{ flex: 0.8 }} name="consultant" placeholder="Consultant" />
                  </Stack>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>TPA</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.8 }}
                      name="tpa"
                      menus={sponsorDropdown.map((data) => ({ ...data, name: data?.name }))}
                    />
                  </Stack>
                  {/* <Stack spacing={0.5} direction="row" justifyContent="center" alignItems="center">
                    <Button variant="contained" color="grey" onClick={() => setAdditionalActionDialogOpen(true)}>
                      Additional Details
                    </Button>
                  </Stack> */}
                </Grid>
                <Grid
                  item
                  xs={4}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 0.3,
                    boxShadow: '0px 2px 2px #0099ff',
                    marginTop: '2%'
                  }}
                >
                  <Table
                    containerSX={{ flex: 1 }}
                    data={groupDetailList.data || []}
                    onRowClick={(row) => setGroupDetailList((prev) => ({ ...prev, activeSelection: row.group }))}
                    columns={GROUP_TABLE_HEADER}
                    size="medium"
                  />
                </Grid>
                <Grid
                  item
                  xs={8}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, boxShadow: '0px 2px 2px #0099ff' }}
                >
                  <Stack direction="row" justifyContent="end" alignItems="center">
                    <Button
                      disabled={!watch('bill.ipd_no') || selectedRow}
                      variant="contained"
                      color="grey"
                      onClick={() => setAddDetailsDialogOpen(true)}
                      
                    >
                      Add Services
                    </Button>
                  </Stack>
                  <FinalBillTable
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)' }}
                    data={serviceList}
                    isSelected={isSelected}
                    handleRowSelect={handleRowSelect}
                    selectedRows={selectedRows}
                    activeSelection={groupDetailList?.activeSelection}
                    columns={SERVICE_NAME_TABLE_HEADER}
                    size="medium"
                    showOk={true}
                    selectedRow={selectedRow}
                    showDeleteAction={true}
                    onDeleteHandler={handleRowDeleteTrigger}
                    showInputField={true}
                    inputValues={inputValues}
                    handleInputChange={handleInputChange}
                  />
                </Grid>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={2} sx={{ mt: 0 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.4rem' }}>Total Net Amt.</Typography>
                      <TextField sx={{ flex: 0.6 }} disabled name="bill.net_amt" placeholder="Total net Amt" />
                    </Stack>
                  </Grid>
                  <Grid item xs={2} sx={{ mt: 0 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Button
                        sx={{ flex: 0.4, textTransform: 'capitalize', padding: '8px' }}
                        color="grey"
                        size="small"
                        variant="contained"
                        onClick={handleQueryWindow}
                      >
                        View Receipt
                      </Button>
                      <TextField sx={{ flex: 0.6 }} disabled name="receipt_voucher_amt" placeholder="View Receipt" />
                    </Stack>
                  </Grid>
                  <Grid item xs={2} sx={{ mt: 0 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Button
                        sx={{ flex: 0.4, textTransform: 'capitalize', padding: '8px' }}
                        color="grey"
                        size="small"
                        variant="contained"
                        onClick={handleQueryWindowRefund}
                      >
                        View Refund
                      </Button>
                      <TextField sx={{ flex: 0.6 }} disabled name="refund_voucher_amt" placeholder="View Refund" />
                    </Stack>
                  </Grid>
                  <Grid item xs={4} sx={{ mt: 0 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Button
                        variant="contained"
                        sx={{ padding: '8px', fontSize: '8px' }}
                        disabled={!watch('add_discount')}
                        onClick={addDiscountAmount}
                      >
                        Add Discount
                      </Button>
                      <TextField sx={{ flex: 0.6 }} name="add_discount" placeholder="Add Discount" />
                      <TextField
                        disabled
                        sx={{ flex: 0.6 }}
                        name="final_bill_discount"
                        placeholder=" Final Bill Disc. Amount"
                      />
                      <TextField disabled sx={{ flex: 0.6 }} name="discounted_amount" placeholder="Disc. Amount" />
                    </Stack>
                  </Grid>
                  <Grid item xs={2} sx={{ mt: 0 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.5, fontWeight: 700, fontSize: '1.4rem' }}>Balance Amt</Typography>
                      <TextField disabled sx={{ flex: 0.6 }} name="bill.balance_amt" placeholder="Balance Amt." />
                    </Stack>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>

      <Dialog
        PaperProps={{ sx: { p: 2 } }}
        open={IPDSearchDialogOpen}
        onClose={() => setIPDSearchDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IPDSearchHandlerBillManagement
          onClose={() => setIPDSearchDialogOpen(false)}
          onAdd={searchIPDRegisterationDetails}
        />
      </Dialog>

      <Dialog
        PaperProps={{ sx: { p: 2 } }}
        open={ipdAllDetailListDialogue}
        onClose={() => setIpdAllDetailListDialogue(false)}
        scroll="body"
        maxWidth="xl"
      >
        <IPDSearchHandlerAllBillManagement
          onClose={() => setIpdAllDetailListDialogue(false)}
          onAdd={searchIPDRegisterationDetailfind}
          setSelectedRow={setSelectedRow}
        />
      </Dialog>
      <Dialog
        PaperProps={{ sx: { p: 2 } }}
        open={additionalActionDialogOpen}
        onClose={() => setAdditionalActionDialogOpen(false)}
        scroll="body"
        maxWidth="xl"
      >
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Additional Actions
          </Typography>
          <IconButton onClick={() => setAdditionalActionDialogOpen(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack spacing={1} sx={{ mt: 3, maxWidth: '20rem', mx: 'auto' }} alignItems="center">
          {[{ label: 'Add Indoor Service', to: '/hospital/hms/indoor-service' }].map(({ label, to }) => (
            <Button
              variant="contained"
              onClick={() => {
                window.open(to, '_blank');
              }}
            >
              {label}
            </Button>
          ))}
        </Stack>
      </Dialog>
      <Dialog open={openPrint} onClose={() => setOpenPrint(false)}>
        <IndoorBillingManagementReport onClose={() => setOpenPrint(false)} reportId={reportId} />
      </Dialog>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Receipt Voucher's of Patient
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 3 }}
          columns={TABLE_HEADER}
          data={receiptVoucherDataObj.data || []}
          loading={receiptVoucherDataObj.loading}
        />
      </Dialog>

      <Dialog
        open={refundQueryWindow}
        onClose={() => setRefundQueryWindow(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={1.5}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Payment Refund Voucher's of Patient
          </Typography>
          <IconButton onClick={() => setRefundQueryWindow(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Table
          sx={{ mt: 3 }}
          columns={REFUND_TABLE_HEADER}
          data={refundVoucherDataObj.data || []}
          loading={refundVoucherDataObj.loading}
        />
      </Dialog>

      <Dialog
        open={addDetailsDialogOpen}
        onClose={() => setAddDetailsDialogOpen(false)}
        PaperProps={{ sx: { width: '80%', height: '80vh', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <FinalBillAddDetailsForm
          doctorID={doctorIDRef.current}
          sponsorID={sponsorIDRef.current}
          onClose={() => setAddDetailsDialogOpen(false)}
          editData={editData}
          isEditMode={isEditMode}
          serviceDropdown={serviceDropdown}
          testDropdown={testDropdown}
          onAdd={onDetailAddHandler}
          setAddDetailsDialogOpen={setAddDetailsDialogOpen}
          groupValue={groupDetailList.activeSelection}
        />
      </Dialog>

      <Dialog open={confirmDialogue} sx={{ '& .MuiDialog-paper': { minHeight: '200px', height: 'auto' } }}>
        <Stack sx={{ height: '100%' }}>
          <Stack
            direction="row"
            spacing={1}
            alignItems="center"
            justifyContent="space-between"
            borderBottom="1px solid"
            borderColor="grey.300"
            sx={{ padding: '16px 24px' }}
          >
            <Typography variant="h4" fontWeight="bold">
              Confirm Delete
            </Typography>
            <IconButton onClick={() => setConfirmDialogue(false)}>
              <CloseIcon color="error" fontSize="large" />
            </IconButton>
          </Stack>

          <Grid container spacing={2} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Typography sx={{ fontWeight: 700, fontSize: '1.6rem' }}>Click Ok To Delete</Typography>
            </Grid>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center', paddingX: 2 }}>
              <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  sx={{
                    minWidth: 120,
                    padding: '8px 20px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    borderRadius: 2
                  }}
                  onClick={handleConfirmDelete}
                >
                  OK
                </Button>
                <Button
                  variant="outlined"
                  color="error"
                  onClick={() => setConfirmDialogue(false)}
                  sx={{
                    minWidth: 120,
                    padding: '8px 20px',
                    fontSize: '1rem',
                    fontWeight: 'bold',
                    borderRadius: 2
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Stack>
      </Dialog>
    </>
  );
};
